import React, {useEffect, useState} from 'react';
import {Button, Spin} from 'antd';
import {useAuthContext} from 'hooks/index';
import { Container, Col, Row } from 'react-bootstrap';
import {GrWindows} from 'react-icons/all';
import {LoadingOutlined} from '@ant-design/icons';
import { useSelector } from 'react-redux';

import 'styles/MSLanding.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'styles/NSWHLogo.scss';
import {getBrandingLogoByTenant} from "api/branding";
import logo from "assets/images/5f-dark-logo.png";

export default ({ isLoading }) => {
    const { login } = useAuthContext();
    const tenantState = useSelector((state) => state.tenant);
    const loaderIcon = <LoadingOutlined spin/>
    const [currentLogo, setCurrentLogo] = useState(getBrandingLogoByTenant(tenantState.uniqueId));

    return (
        <Container className='Admin-Landing-Container'>
            <Row className='Container-Header'>
                <Col>
                    {/*<img className='NSWH-Logo' src={ logo } />*/}
                    <img className='NSWH-Logo' src={currentLogo} onError={() => setCurrentLogo(logo)} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <h2 style={{ fontSize: '3rem' }}>{tenantState.branding.page.appTitle || 'Digital Patient Journey'}</h2>
                </Col>
            </Row>
            <Row>
                <Col>
                    {
                        isLoading ? <Spin indicator={loaderIcon} /> :
                            <Button
                                type='primary'
                                style={{ fontSize: '2rem', height: 'auto' }}
                                size='large'
                                onClick={login}>
                                <GrWindows className='font-larger'/> &nbsp; Sign In with Microsoft
                            </Button>
                    }
                </Col>
            </Row>
        </Container>

    );
}